import { useLayoutEffect, useState, type RefObject } from 'react'
import { getPreviewPlacement, type PreviewPlacement } from '../lib/previewPlacement'

/** The preview's 20rem min width plus 2rem margins on both sides */
const MIN_SPACE = 384

/** Places the open preview beside the view, measured again whenever the view resizes */
export const usePreviewPlacement = (
  viewRef: RefObject<HTMLElement | null>,
  isOpen: boolean
): PreviewPlacement | undefined => {
  const [placement, setPlacement] = useState<PreviewPlacement | undefined>(undefined)

  useLayoutEffect(() => {
    const view = viewRef.current

    if (!isOpen || !view) {
      return
    }

    // Also called once when observing starts
    const observer = new ResizeObserver(() => {
      setPlacement(getPreviewPlacement(view.getBoundingClientRect(), window.innerWidth, MIN_SPACE))
    })

    observer.observe(view)

    return () => {
      observer.disconnect()
    }
  }, [viewRef, isOpen])

  return placement
}
